import { useMutation } from "@tanstack/react-query";
import { appointmentService } from "..";
import { CreateMerchantServiceCategoryPayload } from "../type";

function useCreateMerchantServiceCategory() {
  return useMutation({
    mutationFn: (command: CreateMerchantServiceCategoryPayload) => {
      return appointmentService.addMerchantServicesCategory(command);
    },
  });
}

export default useCreateMerchantServiceCategory;
